
import { Observable } from "rxjs";
import { Subscription } from "../models/subscription";
import { Injectable, Injector } from "@angular/core";
import { ESubscriptionType } from "../enum/e-subscription-type";
import { Package } from "../../packages/models/package";

@Injectable({
  providedIn: 'root'
})
export abstract class SubscriptionService {
  constructor(
    public injector: Injector
  ) {

  }

  public abstract getSubscriptions(discriminator : ESubscriptionType): Observable<Subscription[]>;

  public abstract getSubscription(subscriptionId : number): Observable<Subscription>;

  public abstract GetLastSubscriptionByPackage(packageId : number): Observable<Subscription>;
  
  public abstract createSubscription(subscription: Subscription): Observable<Subscription>;

  public abstract deleteSubscription(subscription: Subscription): Observable<number> ;

  public abstract editSubscription(subscription: Subscription): Observable<any> ;
  
  public abstract getStripeSessionToCheckout(selectedPackage: Package): Observable<any> ;

  public abstract revokeUserSubscriptionBypackage(selectedPackage: Package): Observable<boolean> ;
}
  